import React from "react";
import { Container, Card } from "react-bootstrap";
import "./Policy.css";

// ─── ポリシーセクションデータ（テキスト変更はここだけでOK）────────
const SECTIONS = [
  {
    id: "intro",
    heading: null,
    content: (
      <p>
        株式会社<span className="zenkyo-light">ZENKYO</span>（以下「弊社」という）では、
        弊社ホームページ（以下「当サイト」という）において提供するサービス
        （ホームページによる情報提供、新着情報、Facebook・X・Instagramなど各種SNSを含む）の
        円滑な運営に必要な範囲で、当サイトを利用される皆様の情報を収集しています。
        収集した情報は利用目的の範囲内で適切に取り扱います。
      </p>
    ),
  },
  {
    id: "collection",
    heading: "１．収集する情報の範囲",
    content: (
      <ul>
        <li>(1) インターネットドメイン名、IPアドレス、閲覧履歴、Cookie等のアクセス情報を自動的に収集します。</li>
        <li>(2) お問い合わせフォーム利用時に、企業名、氏名、連絡先、メールアドレス及びお問い合わせ内容を収集します。</li>
      </ul>
    ),
  },
  {
    id: "purpose",
    heading: "２．情報の利用目的",
    content: (
      <ul>
        <li>1.(1) において収集した情報は、当サイトの円滑な運営及び改善のために利用します。</li>
        <li>1.(2) にて収集した情報は、お問い合わせへの回答、資料送付、サービス品質向上及び統計分析に利用します。</li>
      </ul>
    ),
  },
  {
    id: "restriction",
    heading: "３．利用及び提供の制限",
    content: (
      <>
        <p>収集した情報は、法令に基づく開示請求、本人同意、その他特別な事情がある場合を除き、目的外利用及び第三者提供は行いません。</p>
        <p>ただし、統計処理された匿名アクセス情報、または弊社へ危害を加える行為が確認された場合、必要に応じて公表や通報を行うことがあります。</p>
        <p>また、サービス提供のための委託先（広告・分析サービス等）への情報提供が行われる場合があります。</p>
      </>
    ),
  },
  {
    id: "security",
    heading: "４．安全確保の措置",
    content: (
      <p>収集した情報の漏えい、滅失及びき損を防止し、適切な管理を行うため、技術的、組織的、物理的措置を講じます。アクセス制限や暗号化、教育・監査も含まれます。</p>
    ),
  },
  {
    id: "disclosure",
    heading: "５．自己情報の開示",
    content: (
      <>
        <p>当サイトではお問い合わせ情報以外、氏名・生年月日等の個人識別情報を原則収集しておりません（外部SNSを除く）。</p>
        <p>お問い合わせ情報については、本人からの開示・訂正・利用停止請求に応じます。窓口は以下の通りです。</p>
        <address className="ms-3">
          株式会社<span className="zenkyo-light">ZENKYO</span> 個人情報保護窓口<br />
          〒335-0027 埼玉県戸田市氷川町2丁目17番27号<br />
          E-mail: <a href="mailto:inquiry@zenkyo.co.jp">inquiry@zenkyo.co.jp</a>
        </address>
      </>
    ),
  },
  {
    id: "scope",
    heading: "６．適用範囲",
    content: (
      <p>本方針は、当サイト（https://www.zenkyo.co.jp/ 以下のディレクトリ）において適用されます。</p>
    ),
  },
  {
    id: "revision",
    heading: "７．方針の変更",
    content: (
      <p>個人情報保護方針の内容は、必要に応じて改定することがあります。改定した場合は、当サイトにて掲載します。</p>
    ),
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="policy-page">
      <div id="page-top" />
      <Container className="py-5 d-flex justify-content-center">
        <Card className="shadow-lg p-5 rounded-4 policy-card">
          <h1 className="text-center mb-5 policy-title border-bottom pb-3">
            ご利用条件
          </h1>

          {SECTIONS.map(({ id, heading, content }) => (
            <section key={id} className="mb-4">
              {heading && <h2 className="policy-heading">{heading}</h2>}
              {content}
            </section>
          ))}
        </Card>
      </Container>
    </div>
  );
}